<ng-container *ngIf="chip">
	<a class="facet"  
		[routerLink]="'./'" 
		[queryParams]="chip.queryParams"
		queryParamsHandling=""
		[class.selected]="chip.selected"
		matRipple
	 >
		<span class="count" *ngIf="displayCount">{{chip.count}}</span>
		<span class="label">{{chip.entityLabel}}</span>
		<!-- <div class="reset">
			<app-icon class="reset" name="close"></app-icon>
		</div> -->
	</a>
</ng-container>
